<template>
	<div class="waikuang">
		<div class="youce_bg">
			<div class="tit">风险</div>
			<div class="neir">
				<div class="li">
					<div class="i"></div>
					<div class="name">重大风险</div>
					<div class="value">：2类（9个点位）</div>
				</div>
				<div class="li">
					<div class="i"></div>
					<div class="name">较大风险</div>
					<div class="value">：6类 （39个点位 ）</div>
				</div>
				<div class="li">
					<div class="i"></div>
					<div class="name">一般风险</div>
					<div class="value">：13类 （45个点位 ）</div>
				</div>
				<div class="li">
					<div class="i"></div>
					<div class="name">低风险</div>
					<div class="value">：13类（113个点位）</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'secure_risk_check',
	props: {},
	data() {
		return {}
	},
	watch: {},
	mounted () {},
	methods: {}
}
</script>
<style scoped>
.waikuang{
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
}
.waikuang .youce_bg{
	width: 100%;
	background-image: url(~@/assets/img/secure/youce_bg.png);
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	position: relative;
}
.waikuang .youce_bg .tit{
	font-size: 19px;
	color: #02d9fd;
	background-image: url(~@/assets/img/secure/menu_text_bg.png);
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	line-height: 36px;
	width: 100%;
	text-align: center;
	margin-top: -16px;
}
.waikuang .youce_bg+.youce_bg{
	margin-top:45px;
}
.waikuang .youce_bg .neir{
	padding: 20px;
}
.waikuang .youce_bg .neir .li{
	display: flex;
    align-items: center;
	padding: 10px 0;
	font-size: 26px;
	line-height: 1;
}
.waikuang .youce_bg .neir .li .name{
	width: 110px;
	height: 26px;
	text-align: justify;
}
.waikuang .youce_bg .neir .li .name::after{
	content: "";
	display: inline-block;
	height: 1px;
	width: 100%;
}
.waikuang .youce_bg .neir .li .value{
	width: 270px;
}
.waikuang .youce_bg .neir .li .i{
	width: 30px;
	height: 10px;
	margin-right: 10px;
}
.waikuang .youce_bg .neir .li:nth-child(1){
	color: red;
}
.waikuang .youce_bg .neir .li:nth-child(1) .i{
	background: red;
}
.waikuang .youce_bg .neir .li:nth-child(2){
	color: orange;
}
.waikuang .youce_bg .neir .li:nth-child(2) .i{
	background: orange;
}
.waikuang .youce_bg .neir .li:nth-child(3){
	color: yellow;
}
.waikuang .youce_bg .neir .li:nth-child(3) .i{
	background: yellow;
}
.waikuang .youce_bg .neir .li:nth-child(4){
	color: #00f0ff;
}
.waikuang .youce_bg .neir .li:nth-child(4) .i{
	background: #00f0ff;
}
</style>


// WEBPACK FOOTER //
// src/components/secure/secure_risk_check.vue